import { MemberApplicationTaskListdata } from "../data/MemberApplicationTaskList.data";

export const setAllDropDownField = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);
    }

    const dropdownLists = {
        "membershipTypeId": filterDropDownList("Application Type"),
        "statusId": filterDropDownList("TaskList Status"),
    };

    const formFields = [...MemberApplicationTaskListdata.formFields,];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};